import styles from "./toolbox-components.module.css";
import { filterClasses } from "PosterEditor/utils/filter-classes";

interface ToolboxComponentSliderProps {
  title?: string;
  meta?: string; // Displays top right next to title, so good for things like "34 / 100".
  description?: string;
  min: number;
  max: number;
  value: number;
  onChange: (value: number) => void;
  className?: string;
  disabled?: boolean;
}

export const ToolboxComponentSlider = (props: ToolboxComponentSliderProps) => {
  return (
    <div
      className={filterClasses(
        styles.sliderContainer,
        props.disabled ? styles.disabled : ""
      )}
    >
      <div className={styles.sliderTitleContainer}>
        {props.title && (
          <span className={styles.sliderTitle}>{props.title}</span>
        )}
        {props.meta && <span className={styles.sliderMeta}>{props.meta}</span>}
      </div>
      <input
        type="range"
        min={props.min}
        max={props.max}
        value={props.value}
        onChange={(event) => props.onChange(Number(event.target.value))}
        className={`${styles.slider} ${props.className}`}
      />
      {props.description && (
        <span className={styles.sliderDescription}>{props.description}</span>
      )}
    </div>
  );
};
